<div class="spinner container-fluid" [class.spinner-hidden]="!showSpinner">
  <div class="row h-100 w-100 justify-content-center mx-auto">
    <div class="spinner-content col-12 p-3">
      <i class="fas fa-spinner fa-spin fa-5x fa-fw"></i>
      @if (spinnerMessages.length > 0) {
        <h4 class="p-1">{{spinnerMessages[0]}}</h4>
      }
      @if (spinnerMessages.length == 0) {
        <h4 class="p-1">&nbsp;</h4>
      }
    </div>
  </div>
</div>

<div class="spinner-background" [class.spinner-hidden]="!showSpinner"></div>
